import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useStudyAnalyses from 'hooks/useStudyAnalyses';
import { studyAnalysesSelectors } from "features/studyAnalyses";

const StudyAnalysesList = () => {
  const { getStudyAnalyses } = useStudyAnalyses();
  const { data, pagination } = useCustomSelector(studyAnalysesSelectors.getStudyAnalysesData);
  const fetching = useCustomSelector(studyAnalysesSelectors.studyAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getStudyAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <StudyAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);